import React, { FC, useId } from 'react';
import AngleRight from '../../../public/images/angle-right.svg';
import AngleLeft from '../../../public/images/angle-left.svg';
import ArrowLeft from '../../../public/images/arrow-left.svg';
import AngleUp from '../../../public/images/angle-up.svg';
import AngleDown from '../../../public/images/angle-down.svg';
import Search from '../../../public/images/search.svg';
import Accessibility from '../../../public/images/accessibility.svg';
import PpLogo from '../../../public/images/PriorityPass_Logo.svg';
import Instagram from '../../../public/images/Instagram.svg';
import Facebook from '../../../public/images/facebook.svg';
import Youtube from '../../../public/images/youtube.svg';
import Linkedin from '../../../public/images/linkedin.svg';
import Twitter from '../../../public/images/X.svg';
import SmallSearch from '../../../public/images/search-icon.svg';
import PpPrimaryLogo from '../../../public/images/primary-logo.svg';
import PpLogoNew from '../../../public/images/PP Logo.svg';
import PpLogoMobile from '../../../public/images/PP_logo_mobile.svg';
import DinersLogo from '../../../public/images/diners-logo.svg';
import DinersCross from '../../../public/images/diners-cross.svg';
import PpLPLogo from '../../../public/images/Priority_Pass_LP.svg';
import User from '../../../public/images/user.svg';
import SmallClose from '../../../public/images/close-icon.svg';
import SmallCross from '../../../public/images/small-cross.svg';
import Flag from '../../../public/images/flag.svg';
import Airplane from '../../../public/images/airplane.svg';
import Airplane2 from '../../../public/images/Airplane_2.svg';
import AirplaneSearch from '../../../public/images/airplane-search.svg';
import GplayImg from '../../../public/images/Google Play Dark.svg';
import GplayImgLight from '../../../public/images/google-play-light.svg';
import BuildBaby from '../../../public/images/build-icon-baby-facilties.svg';
import BuildFork from '../../../public/images/fork.svg';
import BuildInternet from '../../../public/images/build-icon-internet.svg';
import BuildSeating from '../../../public/images/build-icon-seating.svg';
import BuildShowers from '../../../public/images/facilities/build-icon-showers.svg';
import BuildSockets from '../../../public/images/build-icon-sockets.svg';
import BuildTv from '../../../public/images/build-icon-tv.svg';
import AppleImg from '../../../public/images/ios-app-store.svg';
import AppleImgLight from '../../../public/images/ios-app-store-light.svg';
import ThreeStars from '../../../public/images/threeStars.svg';
import FourStars from '../../../public/images/fourStars.svg';
import FiveStars from '../../../public/images/fiveStars.svg';
import File from '../../../public/images/icon-file-gold.svg';
import GoldenTick from '../../../public/images/golden-tick.svg';
import ChevronUp from '../../../public/images/ChevronUp.svg';
import CaretRight from '../../../public/images/iconmonstr-caret-right-filled.svg';
import GreyTick from '../../../public/images/icon-circle-tick-grey.svg';
import GreenTick from '../../../public/images/icon-circle-tick-green.svg';
import DarkGreenTick from '../../../public/images/icon-circle-tick-dark-green.png';
import InfoCircle from '../../../public/images/i-icon.svg';
import Error from '../../../public/images/error.png';
import StarOutline from '../../../public/images/star-outline.svg';
import StarFilled from '../../../public/images/star-filled.svg';
import LightboxClose from '../../../public/images/lightbox-close.jpg';
import Success from '../../../public/images/success.svg';
import FilledCircleTick from '../../../public/images/filled-circle-tick.svg';
import Image from 'next/image';
import ArrowDownBlack from '../../../public/images/down-black-arrow.svg';
import ErrorIcon from '../../../public/images/error-icon.png';
import paymentCardErrorImage from '../../../public/images/payment-card-error.svg';
import paymentCardSuccessImage from '../../../public/images/payment-card-success.svg';
import CheckboxTick from '../../../public/images/checkbox-tick-large.png';
import CheckboxCheckmark from '../../../public/images/checkbox-checkmark-white.svg';
import EyeOff from '../../../public/images/eye-off.svg';
import Eye from '../../../public/images/eye.svg';
import Tick from '../../../public/images/tick.svg';
import TickWithCircles from '../../../public/images/tick-with-circles.svg';
import Alert from '../../../public/images/alert.svg';
import Help from '../../../public/images/help-support.svg';
import Info from '../../../public/images/info-circle.svg';
import Group from '../../../public/images/Group.svg';
import Checkmark from '../../../public/images/tickmark.svg';
import ArrowBack from '../../../public/images/back-arrow.svg';
import ArrowRight from '../../../public/images/arrow-right.svg';
import AccessDisabled from '../../../public/images/facilities/wheelchair-accessible.svg';
import NoSmoking from '../../../public/images/facilities/no-smoking.svg';
import AirConditioning from '../../../public/images/facilities/air-conditioning.svg';
import FlightInfo from '../../../public/images/facilities/flight-info.svg';
import WiFi from '../../../public/images/facilities/wifi.svg';
import Alcohol from '../../../public/images/facilities/alcoholic-drinks-standard.svg';
import CardPayment from '../../../public/images/facilities/account-card.svg';
import ALaCarteMenu from '../../../public/images/facilities/food-a-la-carte.svg';
import FoodCold from '../../../public/images/facilities/food-cold.svg';
import AlcoholicDrinksPremium from '../../../public/images/facilities/alcoholic-drinks-premium.svg';
import CheckInFacility from '../../../public/images/facilities/check-in-facilities.svg';
import ChildrensPlayArea from '../../../public/images/facilities/kids-playzone.svg';
import ConferenceFacilities from '../../../public/images/facilities/conference.svg';
import DayBeds from '../../../public/images/facilities/sleep-bed.svg';
import FastTrackLane from '../../../public/images/facilities/fast-track-exp.svg';
import Gym from '../../../public/images/facilities/gym.svg';
import DrinkHot from '../../../public/images/facilities/drink-hot.svg';
import FoodHot from '../../../public/images/facilities/food-hot.svg';
import FoodSnacks from '../../../public/images/facilities/food-snacks.svg';
import NewspaperMagazine from '../../../public/images/facilities/newspaper-magazine.svg';
import RunwayView from '../../../public/images/facilities/runway-view.svg';
import ShoeShine from '../../../public/images/facilities/shoe-shine.svg';
import Television from '../../../public/images/facilities/tv.svg';
import Washroom from '../../../public/images/facilities/washroom.svg';
import SoftDrinkCold from '../../../public/images/facilities/drink-soft-cold.svg';
import Cinema from '../../../public/images/facilities/cinema.svg';
import GamesRoom from '../../../public/images/facilities/games-room.svg';
import GolfCartService from '../../../public/images/facilities/golf-cart-service.svg';
import IpadTablet from '../../../public/images/facilities/tablet-ipad.svg';
import Luggages from '../../../public/images/facilities/bag-storage.svg';
import MassageChairs from '../../../public/images/facilities/massage-chair.svg';
import PrayerRoom from '../../../public/images/facilities/prayer-room.svg';
import Printers from '../../../public/images/facilities/printer.svg';
import QuietArea from '../../../public/images/facilities/Quiet-zone.svg';
import Telephone from '../../../public/images/facilities/telephone.svg';
import TelephoneSearch from '../../../public/images/facilities/telephone-search.svg';
import Headset from '../../../public/images/headset.svg';
import ChargingStation from '../../../public/images/facilities/charging-station.svg';
import Salon from '../../../public/images/facilities/salon.svg';
import Workstations from '../../../public/images/facilities/workspace-computer.svg';
import Beer from '../../../public/images/facilities/glass-beer.svg';
import Placeholder from '../../../public/images/facilities/placeholder-icon.svg';
import QrCode from '../../../public/images/qr-code.svg';
import AccountCard from '../../../public/images/facilities/account-card.svg';
import Clock from '../../../public/images/clock.svg';
import Edit from '../../../public/images/edit.svg';
import ProfileLogo from '../../../public/images/profileLogo.svg';
import LoginEye from '../../../public/images/login-eye.svg';
import CardPPLogo from '../../../public/images/CardPPLogo.svg';
import DefaultCross from '../../../public/images/default-cross.svg';
import NewAvatar from '../../../public/images/new-avatar.svg';
import XMark from '../../../public/images/x-mark.svg';
import XMarkCircle from '../../../public/images/x-mark-circle.svg';
import WhiteChevronUp from '../../../public/images/white-chevron-up.svg';
import BlackGreyTick from '../../../public/images/black-grey-tick.svg';
import LongLoadingSpinner from '../../../public/images/long-loading-spinner.svg';
import LongLoadingCheck from '../../../public/images/long-loading-check.svg';
import Loader from '../../../public/images/forgot-details-loader.svg';
import NoticeLogo from '../../../public/images/notice-logo.svg';
import AlertGold from '../../../public/images/alert-gold.svg';
import ChevronLeft from '../../../public/images/chevron-01-left.svg';
import Settings from '../../../public/images/settings.svg';
import GlobalMap from '../../../public/images/global-map.svg';
import DinersGlobalMap from '../../../public/images/diners-global-map.svg';
import DinersConfirmationIcon from '../../../public/images/diners-confirmation-icon.svg';
import DinersChevronRight from '../../../public/images/diners-chevron-right.svg';
import DinersSearch from '../../../public/images/diners-search.svg';
import OutletFacilityTelephone from '../../../public/images/facilities/outlet-facility-telephone.svg';
import LoungeExp from '../../../public/images/lounge-exp.svg';
import UnwindExp from '../../../public/images/unwind-exp.svg';
import RefreshExp from '../../../public/images/refresh-exp.svg';
import EatExp from '../../../public/images/eat-exp.svg';
import RestExp from '../../../public/images/rest-exp.svg';
import LoungeExpFilled from '../../../public/images/lounge-exp-filled.svg';
import UnwindExpFilled from '../../../public/images/unwind-exp-filled.svg';
import RestExpFilled from '../../../public/images/rest-exp-filled.svg';
import RefreshExpFilled from '../../../public/images/refresh-exp-filled.svg';
import EatExpFilled from '../../../public/images/eat-exp-filled.svg';
import Infinite from '../../../public/images/infinite.svg';
import Unlimited from '../../../public/images/unlimited.svg';
import CardLogoVisa from '../../../public/images/card-logo-visa.svg';
import CardLogoMastercard from '../../../public/images/card-logo-mastercard.svg';
import CardLogoAmex from '../../../public/images/card-logo-amex.svg';
import CardLogoMaestro from '../../../public/images/card-logo-maestro.svg';
import SleepPods from '../../../public/images/facilities/sleep-pods.svg';
import AlertTransparent from '../../../public/images/alert-transparent.svg';
import CardLogoChinaUnionPay from '../../../public/images/card-logo-china-union-pay.svg';
import CardLogoDinersClub from '../../../public/images/card-logo-diners-club.svg';
import CardLogoDiscover from '../../../public/images/card-logo-discover.svg';
import CardLogoJaywan from '../../../public/images/card-logo-jaywan.svg';
import CardLogoJcb from '../../../public/images/card-logo-jcb.svg';
import AddToWallet from '../../../public/images/addToWallet.svg';
import Diners75thYearEmblem from '../../../public/images/diners-75th-year-emblem.svg';
import TransparentTick from '../../../public/images/transparent-tick.svg';
import TransparentClose from '../../../public/images/transparent-close.svg';
import AlcoholDrinksAgeLimitInfo from '../../../public/images/facilities/alcoholic-drinks-age-limit-info.svg';
import Laurel from '../../../public/images/laurel.svg';
import LaurelStar from '../../../public/images/laurels_star.svg';
import PriorityPassWordmark from '../../../public/images/Priority_Pass_Wordmark.svg';
import DMCPriorityPassLogo from '../../../public/images/DMC-PriorityPass.svg';
import PrivacyShieldIcon from '../../../public/images/privacy-shield-icon.svg';
import crossIcon from '../../../public/images/cross-icon.svg';
import greenTickIcon from '../../../public/images/green-tick-icon.svg';
import TickInsideOctagram from '../../../public/images/tick-inside-octagram.svg';
import UserNewIcon from '../../../public/images/user_new.svg';
import CancelNewIcon from '../../../public/images/cancel-01.svg';
import SearchNewIcon from '../../../public/images/search_new.svg';
import LogoWithWatermark from '../../../public/images/Logo-wordmark.svg';
import TikTok from '../../../public/images/ppweb-social-tiktok.svg';
import PPOnlyLogo from '../../../public/images/pp-only-logo.svg';
import LockIcon from '../../../public/images/lock.svg';

export const iconMap = {
    angleRight: AngleRight,
    angleLeft: AngleLeft,
    arrowLeft: ArrowLeft,
    angleUp: AngleUp,
    angleDown: AngleDown,
    search: Search,
    a11y: Accessibility,
    ppLogo: PpLogo,
    Instagram,
    Twitter,
    Linkedin,
    Youtube,
    Facebook,
    TikTok,
    smallSearch: SmallSearch,
    primaryLogo: PpPrimaryLogo,
    ppLogoNew: PpLogoNew,
    ppLogoMobile: PpLogoMobile,
    dinersLogo: DinersLogo,
    dinersCross: DinersCross,
    user: User,
    smallClose: SmallClose,
    smallCross: SmallCross,
    defaultCross: DefaultCross,
    flag: Flag,
    airplane: Airplane,
    airplane2: Airplane2,
    airplaneSearch: AirplaneSearch,
    ppLpLogo: PpLPLogo,
    buildBaby: BuildBaby,
    buildFork: BuildFork,
    buildInternet: BuildInternet,
    buildSeating: BuildSeating,
    buildTv: BuildTv,
    buildSockets: BuildSockets,
    showers: BuildShowers,
    threeStars: ThreeStars,
    fourStars: FourStars,
    fiveStars: FiveStars,
    file: File,
    'Google Play': GplayImg,
    'App Store': AppleImg,
    'Google Play (Light)': GplayImgLight,
    'App Store (Light)': AppleImgLight,
    goldenTick: GoldenTick,
    greyTick: GreyTick,
    blackGreyTick: BlackGreyTick,
    whiteChevronUp: WhiteChevronUp,
    greenTick: GreenTick,
    darkGreenTick: DarkGreenTick,
    chevronUp: ChevronUp,
    loader: Loader,
    caretRight: CaretRight,
    arrowDownBlack: ArrowDownBlack,
    infoCircle: InfoCircle,
    error: Error,
    lightboxClose: LightboxClose,
    starOutline: StarOutline,
    starFilled: StarFilled,
    success: Success,
    errorIcon: ErrorIcon,
    paymentCardError: paymentCardErrorImage,
    paymentCardSuccess: paymentCardSuccessImage,
    checkboxTick: CheckboxTick,
    checkboxCheckmark: CheckboxCheckmark,
    eyeOff: EyeOff,
    eye: Eye,
    tick: Tick,
    tickWithCircles: TickWithCircles,
    alert: Alert,
    help: Help,
    info: Info,
    group: Group,
    checkmark: Checkmark,
    arrowback: ArrowBack,
    arrowRight: ArrowRight,
    disabledAccess: AccessDisabled,
    noSmoking: NoSmoking,
    airConditioning: AirConditioning,
    flightInformationMonitor: FlightInfo,
    wifi: WiFi,
    alcoholicDrinks: Alcohol,
    digitalMembershipCard: CardPayment,
    aLaCarteMenu: ALaCarteMenu,
    alcoholicDrinksAgeLimit: AlcoholDrinksAgeLimitInfo,
    alcoholicDrinksPremium: AlcoholicDrinksPremium,
    checkInFacility: CheckInFacility,
    childrensPlayArea: ChildrensPlayArea,
    coldBuffet: FoodCold,
    conferenceFacilities: ConferenceFacilities,
    fastTrackLane: FastTrackLane,
    filledCircleTick: FilledCircleTick,
    dayBeds: DayBeds,
    hotBuffet: FoodHot,
    hotDrinks: DrinkHot,
    newspapersMagazines: NewspaperMagazine,
    shoeShine: ShoeShine,
    snacks: FoodSnacks,
    softDrinks: SoftDrinkCold,
    televisions: Television,
    viewOfRunway: RunwayView,
    washrooms: Washroom,
    gym: Gym,
    cinema: Cinema,
    gamesRoom: GamesRoom,
    complimentaryDrinksNumber: SoftDrinkCold,
    golfCartService: GolfCartService,
    ipadTablet: IpadTablet,
    luggageStorage: Luggages,
    massageChairs: MassageChairs,
    napRoom: QuietArea,
    prayerRoom: PrayerRoom,
    printers: Printers,
    quietArea: QuietArea,
    telephone: Telephone,
    telephoneSearch: TelephoneSearch,
    headset: Headset,
    complimentaryAlcoholicDrinksNumber: Alcohol,
    complimentaryDrinksLimitedBeer: Beer,
    complimentaryDrinksLimitedBeerWine: Placeholder,
    rechargingStation: ChargingStation,
    spaSalon: Salon,
    workstations: Workstations,
    cardPayment: CardPayment,
    qrCode: QrCode,
    accountCard: AccountCard,
    clock: Clock,
    edit: Edit,
    profileLogo: ProfileLogo,
    loginEye: LoginEye,
    cardPPLogo: CardPPLogo,
    newAvatar: NewAvatar,
    XMark: XMark,
    XMarkCircle: XMarkCircle,
    longLoadingSpinner: LongLoadingSpinner,
    longLoadingCheck: LongLoadingCheck,
    noticeLogo: NoticeLogo,
    alertGold: AlertGold,
    infinite: Infinite,
    chevronLeft: ChevronLeft,
    settings: Settings,
    globalMap: GlobalMap,
    dinersGlobalMap: DinersGlobalMap,
    dinersConfirmationIcon: DinersConfirmationIcon,
    dinersChevronRight: DinersChevronRight,
    dinersSearch: DinersSearch,
    outletFacilityTelephone: OutletFacilityTelephone,
    loungeExp: LoungeExp,
    unwindExp: UnwindExp,
    refreshExp: RefreshExp,
    eatExp: EatExp,
    restExp: RestExp,
    loungeExpFilled: LoungeExpFilled,
    eatExpFilled: EatExpFilled,
    refreshExpFilled: RefreshExpFilled,
    restExpFilled: RestExpFilled,
    unwindExpFilled: UnwindExpFilled,
    unlimited: Unlimited,
    cardLogoVisa: CardLogoVisa,
    cardLogoMastercard: CardLogoMastercard,
    cardLogoAmex: CardLogoAmex,
    cardLogoMaestro: CardLogoMaestro,
    sleepPods: SleepPods,
    alertTransparent: AlertTransparent,
    cardLogoChinaUnionPay: CardLogoChinaUnionPay,
    cardLogoDinersClub: CardLogoDinersClub,
    cardLogoDiscover: CardLogoDiscover,
    cardLogoJaywan: CardLogoJaywan,
    cardLogoJcb: CardLogoJcb,
    fallbackCardLogo: AccountCard,
    addToAppleWallet: AddToWallet,
    diners75thYearEmblem: Diners75thYearEmblem,
    transparentTick: TransparentTick,
    transparentClose: TransparentClose,
    laurel: Laurel,
    laurelStar: LaurelStar,
    priorityPassWordmark: PriorityPassWordmark,
    dmcPriorityPassLogo: DMCPriorityPassLogo,
    privacyShieldIcon: PrivacyShieldIcon,
    crossIcon: crossIcon,
    greenTickIcon: greenTickIcon,
    tickInsideOctagram: TickInsideOctagram,
    userNewIcon: UserNewIcon,
    cancelNewIcon: CancelNewIcon,
    searchNewIcon: SearchNewIcon,
    logoWithWatermark: LogoWithWatermark,
    ppOnlyLogo: PPOnlyLogo,
    lockIcon: LockIcon,
};

export type IconType = keyof typeof iconMap;

export interface IconProps {
    type: IconType;
    className?: string;
    width?: number;
    height?: number;
    onClick?: (e?: unknown) => void;
    active?: boolean;
    alt?: string;
    role?: 'img' | 'presentation';
    ariaLabel?: string;
    'aria-hidden'?: boolean | 'true' | 'false';
    'data-testid'?: string;
    priority?: boolean;
}

export const Icon: FC<IconProps> = ({
    type,
    width,
    height,
    role = 'img',
    alt = '',
    priority = false,
    ariaLabel,
    'aria-hidden': ariaHidden,
    'data-testid': dataTestId,
    ...other
}) => {
    const IconComponent = iconMap[type];
    const uniqueId = useId();
    const description = ariaLabel || type;
    const isHidden = ariaHidden === true || ariaHidden === 'true';

    if (!IconComponent) {
        return null;
    }

    if (typeof IconComponent === 'object') {
        // It's an image import
        return (
            <Image
                priority={priority}
                src={IconComponent}
                width={width}
                height={height}
                alt={isHidden ? '' : alt || `${type} icon`}
                aria-hidden={ariaHidden}
                {...other}
                data-testid={dataTestId ?? `icon-${type}`}
            />
        );
    }

    // It's an SVG import
    const { style, ...svgProps } = other as { style?: React.CSSProperties };
    const dimensionStyle: React.CSSProperties = {
        ...(width !== undefined ? { width, minWidth: width } : {}),
        ...(height !== undefined ? { height, minHeight: height } : {}),
    };

    return (
        <IconComponent
            {...(width !== undefined ? { width } : {})}
            {...(height !== undefined ? { height } : {})}
            style={{ ...dimensionStyle, ...style }}
            {...svgProps}
            data-testid={dataTestId ?? 'icon'}
            aria-hidden={ariaHidden}
            role={isHidden || role === 'presentation' ? undefined : role}
            aria-label={isHidden || role === 'presentation' ? undefined : description}
            id={`icon-${uniqueId}`}
        />
    );
};

export default Icon;
